import {message} from "antd";

export const getRootPath = (url) => {
    if(typeof url === 'undefined' || url === '/') {
        return url;
    }

    const position = url.indexOf('/', 2);

    if(position === -1) {
        return url;
    }

    return url.substr(0, position);
};

export const compareArrays = (a, b) => {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
};

export const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
};

export const displayErrors = (data) => {
    if(typeof data.errors !== 'undefined') {
        for(let i = 0; i < data.errors.length; i++) {
            message.error(data.errors[i]);
        }
    }

    if(typeof data.error !== 'undefined') {
        message.error(data.error);
    }
};

export const normalizeEnum = (text, capitalize_all = true) => {
    if(typeof text === 'undefined') {
        return '';
    }

    let items = [];
    let pieces = text.toLowerCase().split('_');

    for(let i = 0; i < pieces.length; i++) {
        let text = pieces[i][0].toUpperCase() + pieces[i].substring(1);
        items.push(text);
    }

    if(capitalize_all) {
        let result =  items.join(' ');

        if(result === 'Ip Address') {
            return 'IP Address';
        }

        return result;
    } else {
        text = items.join(' ').toLowerCase();
        let result =  text[0].toUpperCase() + text.substring(1);

        if(result === 'Ip Address') {
            return 'IP Address';
        }

        return result;
    }
}


export const convertBytes = function(bytes) {
    const sizes = ["B", "KB", "MB", "GB", "TB"]

    if (bytes === 0) {
        return "n/a"
    }

    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

    if (i === 0) {
        return bytes + " " + sizes[i]
    }

    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i]
}

export const shuffleArray = function(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    while(0 !== currentIndex){
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}

export const generateRandomString = (length = 16) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export const getCookieValue = (name) => (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
)